<template>
  <scoped v-if="supplier">
    <h1>
      Supplier
    </h1>
    <table>
      <tbody>
        <tr>
          <th>
            Name
          </th>
          <td>
            {{ supplier.name }}
          </td>
        </tr>
        <tr>
          <th>
            Memorandum
          </th>
          <td>
            {{ supplier.memorandum }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="supplier.contactDetails">
      <h2>
        Contact Details
      </h2>
      <ContactDetailsList 
        v-model:selectedIndex="selectedContactDetailsIndex"
        :items="supplier.contactDetails.records"
        readOnly
      />
      <ContentModal v-if="selectedContactDetailsIndex != null">
        <ContactDetailsEditor
          :value="supplier.contactDetails.records[selectedContactDetailsIndex]"
          readOnly
        />
        <br>
        <Button
          title="Close"
          @click="selectedContactDetailsIndex = null"
        />
      </ContentModal>
    </div>
    <div v-if="supplier.orders && supplier.orders.records">
      <h2>
        Orders
      </h2>
      <OrderList
        v-model:selectedIndex="selectedOrderIndex"
        :items="supplier.orders.records"
      />
      <ContentModal v-if="selectedOrderIndex != null">
        <PurchaseOrderEditor
          :value="supplier.orders.records[selectedOrderIndex]"
          readOnly
        />
        <br>
        <Button
          title="Close"
          @click="selectedOrderIndex = null"
        />
      </ContentModal>
    </div>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import ContentModal from "@/components/modals/content.vue"
  import ContactDetailsEditor from  "@/components/editors/contact_details.vue"
  import ContactDetailsList from  "@/components/lists/contact_details.vue"
  import {Supplier as SupplierClient} from "@/endpoints/rutsolve/gql/resolvers/supplier"
  import {onBeforeMount, ref} from "vue"
  import {Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import PurchaseOrderEditor from "@/components/editors/purchase_order.vue"
  import OrderList from "@/components/lists/order.vue"

  const props = defineProps({
    supplierID: {
      default: null,
      required: true,
      type: String
    }
  })

  const error = ref<Error>(null)
  const supplierClient = new SupplierClient()
  const supplier = ref<Supplier>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const selectedOrderIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      supplier.value = await supplierClient.summary(props.supplierID)
    } catch(e) {
      error.value = e
    }
  }
</script>
